module.exports = __webpack_public_path__ + "assets/img/gzh.c9667d4b.png";